import { App, type URLOpenListenerEvent } from '@capacitor/app'
import { Logger } from '@egw/logger'
import { notifications, NOTIFICATIONS } from '@egw/notifications'

const log = new Logger('Deep Linking Service')

let instance: DeepLinkingService | null = null

class DeepLinkingService {
  private isInitialized = false

  constructor() {
    if (!instance) {
      instance = this
    }
  }

  init(): void {
    if (!this.isInitialized) {
      this.isInitialized = true
      void App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        notifications.dispatch(NOTIFICATIONS.DEEP_LINKING.APP_URL_OPEN, {
          url: event.url,
        })
      })
      log.info('Service initialized')
    } else {
      log.warn('Service is already initialized. Skipping initialization...')
    }
  }
}

export const deepLinkingService = new DeepLinkingService()
